import React, { type PropsWithChildren, useMemo } from 'react';

import type { SearchQueryStringParams } from '../../../../../common/constants/schemas/query-params';
import { parseQueryParams } from '../../../../../common/utils/query-params';
import type { BootstrapContainerProps } from '../../index';
import { DynamicBootstrapContext } from '../index';

export const DynamicContextProvider = ({
	children,
	...props
}: PropsWithChildren<BootstrapContainerProps>): React.JSX.Element => {
	// QueryParms change as the input/filters change
	const queryParams = useMemo(() => {
		return props.queryParams || defaultDynamicContext.queryParams;
	}, [props.queryParams]);

	// Referrer may be set on init but is then cleared on first render, therefore dynamic
	const referrer = useMemo(() => {
		const parsedQueryParams = queryParams && parseQueryParams(queryParams);
		return parsedQueryParams?.referrer || defaultDynamicContext.referrer;
	}, [queryParams]);

	// A classic anything-updates useMemo
	const dynamicProps: DynamicBootstrapContextState = useMemo(() => {
		return {
			queryParams,
			referrer,
		};
	}, [queryParams, referrer]);

	return (
		<DynamicBootstrapContext.Provider value={dynamicProps}>
			{children}
		</DynamicBootstrapContext.Provider>
	);
};

export type DynamicBootstrapContextState = {
	queryParams: SearchQueryStringParams; // TODO QS-8570 this is in AppContext, could maybe use that instead?
	referrer: string | undefined; // TODO QS-8571 can this be moved to static context? It is read + removed on page load
};

export const defaultDynamicContext = {
	queryParams: {},
	referrer: undefined,
};
